import React from 'react';
import './HeaderBar.css';

export default function HeaderBar({ currentUser, userRole, onLogout, onProfile }) {
  if (!currentUser) return null;
  const roleLabel = userRole === 'admin' ? '管理员' : userRole === 'sales' ? '销售' : '招生';

  return (
    <header className="global-header">
      <div className="header-row-1">
        <span className="header-logo">家政管理</span>
        <div className="header-user-info">
          {currentUser.avatar_url && (
            <img className="header-avatar" src={currentUser.avatar_url} alt="头像" />
          )}
          <span className="header-nickname">{currentUser.nickname || currentUser.real_name}</span>
          <span className="header-role-tag">{roleLabel}</span>
        </div>
      </div>
      <div className="header-row-2">
        {userRole === 'admin' && (
          <button className="header-admin-btn" onClick={() => window.dispatchEvent(new CustomEvent('navigate', {detail: 'register'}))}>
            注册新用户
          </button>
        )}
        {userRole === 'admin' && (
          <button className="header-admin-btn" onClick={() => window.dispatchEvent(new CustomEvent('navigate', {detail: 'password-reset'}))}>
            密码重置
          </button>
        )}
        <button className="header-profile-btn" onClick={onProfile}>个人中心</button>
        <button className="header-logout-btn" onClick={onLogout}>退出</button>
      </div>
    </header>
  );
}